import { Signup } from '@bz/account';

export const route: RouteDefinition = {
  preload: () => {
    // return get.getMarketTypeList({sportType: Number(params.sportType)});
  },
  info: {
    dialog: {
      get title() {
        return t('Sign up');
      },
      class: 'h-[700px] w-[500px] rounded-[8px] bg-layer3_5-card',
    },
  },
};

export default Signup;
